import { ReactNode } from 'react';
import styled from 'styled-components';

import { Text } from '../../../cdl/Text/Text';

import { sidebarMenuItemStyles } from './sidebarMenuItemStyles';

const StyledSidebarMenuItem = styled.button`
    ${sidebarMenuItemStyles};
    border: none;
    cursor: pointer;
    background: transparent;
`;

interface SidebarMenuItemProps {
    children: ReactNode;
    onClick: () => void;
}

export const SidebarMenuItem = ({ children, onClick }: SidebarMenuItemProps) => {
    return (
        <StyledSidebarMenuItem onClick={onClick}>
            <Text variant="fieldLabel">{children}</Text>
        </StyledSidebarMenuItem>
    );
};
